export default __webpack_public_path__ + "static/media/arabica-2.664e51e9.jpg";